import { TweenMax, easeOut } from 'gsap/all';

const loaderView = document.getElementById('loader');

function Loader() {
    var bars = document.querySelectorAll('#loader .bar');
    const interval = setInterval(function() {
        if(document.readyState === 'complete') {
            clearInterval(interval);
            new TimelineMax()

                .to(bars, 0.3, { opacity: 0 })
                .to(loaderView, 0.6, {
                    scaleY: 0,
                    transformOrigin: 'center bottom',
                    ease:Cubic.easeOut,
                    onComplete: () => {
                        TweenMax.set('body', { overflow: 'auto' })
                        setTimeout(() => {
                            loaderView.style.display = 'none';
                        }, 100);
                    }
                })
        }
    }, 100);
}


export default Loader;



// WEBPACK FOOTER //
// ./resources/js/components/Loader.js